import { Router, UrlTree } from '@angular/router';
import { ProjectUserRole } from '@models/projects';

export function isCustomerRole(role: ProjectUserRole | null | undefined): boolean {
  return role === 'Customer';
}

export function customerMessagesUrlTree(router: Router, projectId: string): UrlTree {
  return router.createUrlTree(['/projects', projectId, 'customer-messages']);
}
